import { AbstractControl } from '@angular/forms';
import { PeselService } from '../services/pesel.service';

export function PeselLegalAgeValidator(control: AbstractControl) {

  let pesel = control.value;
  if (pesel === null || pesel === undefined || pesel.length === 0) {
    // if pesel is not present, dont send error, use Validators.required
    return null;
  }
  if (pesel.length !== 11) {
    return {validPeselLength: false};
  }
  let birthDate = PeselService.getBirthdate(pesel);
  if (!(birthDate instanceof Date) || isNaN(birthDate.valueOf())) {
    return {validPeselBirthDate: false};
  } else {
    let today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    let m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    if (age >= 18) {
      return true;
    } else {
      return {validPeselLegalAge: false};
    }
  }
}
